<template>
  <div class="member-detail bgc-gradient">
    <Header :number="0"></Header>
    <div class="member-container">
      <div class="container-top" @click="getInfo">
        <div class="member-photo">
          <div class="member-img">
            <van-image v-if="userInfo.headUrl" :src="userInfo.headUrl" class="photo">
              <template v-slot:error>
                <img class="default" src="@/assets/imgs/personal/avatar.png"/>
              </template>
            </van-image>
            <img v-else class="default" src="@/assets/imgs/personal/avatar.png"/>
          </div>
          <div class="member-info">
            <p class="member-name">{{ userInfo.realName }}</p>
            <p class="member-company">
              <img src="@/assets/imgs/personal/vipInsignia.png"/>
              <span>{{ userInfo.companyAuthModel.companyName }} </span>
            </p>
          </div>
          <!-- <div class="member-arrow" @click="getInfo">
            点击编辑资料
            <van-icon name="play" style="top: 0.03rem" />
          </div> -->
        </div>
      </div>
      <PersonalButton></PersonalButton>

      <div class="member-func__block">
        <div class="header">
          <div class="title">
            我的订单
          </div>
          <div class="line" @click="toOrder('')">
            查看全部
            <img alt="" src="@/assets/imgs/personal/更多@2x.png">
          </div>
        </div>
        <div class="body">
          <div class="row">
            <div class="item" @click="toOrder('0_1,0_2,0_3')">
              <img src="@/assets/imgs/personal/pendingConfirmation.png"/>
              <p>待确认</p>
            </div>
            <div class="item" @click="toOrder('1,1_1,2_3')">
              <img src="@/assets/imgs/personal/pendingAudit.png"/>
              <p>待审核</p>
            </div>
            <div class="item" @click="toOrder('2,2_2')">
              <img src="@/assets/imgs/personal/audit.png"/>
              <p>审核中</p>
            </div>
            <div class="item" @click="toOrder('3')">
              <img src="@/assets/imgs/personal/pendingShipment.png"/>
              <p>待发货</p>
            </div>
            <div class="item" @click="toOrder('4')">
              <img src="@/assets/imgs/personal/shipping.jpg"/>
              <p>发货中</p>
            </div>
          </div>
        </div>
      </div>

      <div class="member-func__block">
        <div class="header">
          <div class="title">
            我的服务
          </div>
          <div class="line" @click="toOrder">
          </div>
        </div>
        <div class="body">
          <div class="row service">
            <div class="item" @click="toRoute('/contract')">
              <img src="@/assets/imgs/personal/contractManagement.png"/>
              <p>合同管理</p>
            </div>
            <div class="item" @click="toRoute('/deliveryPersonList')">
              <img src="@/assets/imgs/personal/consignor.png"/>
              <p>提货人</p>
            </div>
            <div class="item" @click="toRoute('/vehicleList')">
              <img src="@/assets/imgs/personal/vehicleAndVesselManagement.png"/>
              <p>车船管理</p>
            </div>
            <div class="item" @click="toRoute('/invoice')">
              <img src="@/assets/imgs/personal/invoiceManagement.png"/>
              <p>发票管理</p>
            </div>
            <div class="item" @click="toRoute('/carrier')">
              <img src="@/assets/imgs/personal/carrier.png"/>
              <p>承运商</p>
            </div>
          </div>
        </div>
        <div class="body">
          <div class="row service">
            <div class="item" @click="toRoute('/currentAccountConfirmation')">
              <img src="@/assets/imgs/personal/confirmation.png"/>
              <p>往来账书</p>
            </div>
            <div class="item" @click="toRoute('/guestDeposit')">
              <img src="@/assets/imgs/personal/inventoryInquiry.png"/>
              <p>库存查询</p>
            </div>
            <div class="item" @click="toRoute('/complaintList')">
              <img src="@/assets/imgs/personal/complaintSuggestion.png"/>
              <p>投诉建议</p>
            </div>
            <div class="item" @click="toRoute('/services')">
              <img src="@/assets/imgs/personal/expertServices.png"/>
              <p>专家服务</p>
            </div>
            <div class="item" @click="toRoute('/aboutUs')">
              <img src="@/assets/imgs/personal/aboutUs.png"/>
              <p>关于我们</p>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import Header from "./components/PersonalHeader.vue";
import PersonalButton from "./components/Button";
import accountApi from "@/request/accountApi";
// import DialogComponents from '@/components/Dialog/Dialog.vue'
export default {
  name: "Personal",
  components: {
    Header,
    PersonalButton,
    // DialogComponents
    // Cell,
  },
  data() {
    return {
      headerTitle: "个人中心",
      value: "",
      activeNames: [],
      isAudit: "",
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    headUrl() {
      let url =
          this.userInfo && this.userInfo.headUrl
              ? this.userInfo.headUrl
              : "@/assets/imgs/user/user.jpg";
      return url;
    },
    toUpdateMobile() {
      return `/updatePhoneNumber?mobile=${this.userInfo.mobilePhone}`;
    },
  },
  created() {
    this.getIsAudit();
  },
  methods: {
    getInfo() {
      this.$router.push("/personalInfoMaintenance");
    },
    toOrder(acitve = '') {
      this.$router.push('/order?active=' + acitve)
    },
    toRoute(url = '/') {
      this.$router.push(url)
    },
    // 请求认证审核情况
    async getIsAudit() {
      let params = Object.assign({});
      let res = await accountApi.getIsAuthed(params);
      if (res.success) {
        if (res.result) {
          console.log(3333, res.result);
          this.isAudit = res.result.companyAuthModel.companyStatus;
          this.attestModal();
        }
      }
    },
    attestModal() {
      let userInfo = this.userInfo;
      // isAuthed 是否认证
      if (
          userInfo &&
          userInfo.companyAuthModel.isAuthed &&
          userInfo.companyAuthModel.isAuthed == "1"
      ) {
        //已认证
        return;
      } else {
        //未认证
        if (this.isAudit == "01") {
          //
          //未提交认证
          this.$dialog.confirm({
            title: "认证审核中",
            message:
                "认证审核中,请尽快联系平台客服审核通过,以便使用平台的相关服务功能。",
            okText: "去首页",
            onOk: () => {
              //跳到待审核页面 缺原型页面
              this.$router.push("/home");
              // this.$router.push("/registered/attest");
              // this.$Message.info("待审核");
            },
          });
        } else if (this.isAudit == "02") {
          //审核通过
          return;
        } else {
          //提交认证未审核
          this.$dialog
              .confirm({
                title: "未实名认证",
                message: "请尽快完成企业实名认证，以便使用平台的相关服务功能。",
                confirmButtonText: "去认证",
              })
              .then(() => {
                this.$router.push("/authentication");
              });
        }
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.member-detail {
  display: flex;
  flex-direction: column;
  height: auto;
  padding: 0 0.2rem;
  flex: 1;
  overflow: auto;

  .member-container {
    .container-top {
      margin-bottom: 26px;

      .member-photo {
        display: flex;
        flex-direction: row;
        position: relative;

        .member-img {
          display: flex;
          align-items: center;
          justify-content: center;

          .photo {
            width: 112px;
            height: 112px;
            border-radius: 50%;

            /deep/ img {
              border-radius: 50%;
            }

            /deep/ .van-image__error {
              border-radius: 50%;
            }
          }

          .default {
            width: 112px;
            height: 112px;
            border-radius: 50%;
          }
        }

        .member-info {
          margin-left: 16px;

          .member-name {
            height: 0.75rem;
            line-height: 0.75rem;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 32px;
            color: #333333;
          }

          .member-company {
            display: block;
            display: flex;

            img {
              width: 32px;
              height: 32px;
              margin-right: 10px;
            }

            span {
              flex: 1;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 24px;
              color: #FEA633;
              line-height: 28px;
            }
          }
        }

        .member-arrow {
          position: absolute;
          padding-left: 0.1rem;
          right: -0.2rem;
          top: 0.15rem;
          width: 2.02rem;
          height: 0.46rem;
          border-top-left-radius: 0.24rem;
          border-end-start-radius: 0.24rem;
          background-color: rgba(228, 115, 46, 1);
          box-shadow: 0rem 0.08rem 0.2rem 0rem rgba(187, 83, 20, 0.25);
          line-height: 0.46rem;
          color: rgba(255, 255, 255, 1);
          font-size: 0.24rem;
          text-align: center;
          letter-spacing: 0.01rem;
          font-family: SourceHanSansCN-Regular;
        }
      }
    }

    .member-func__block {
      border-radius: 0.16rem;
      background-color: rgba(255, 255, 255, 1);
      // box-shadow: 0rem 0.04rem 0.6rem 0rem rgba(254, 236, 217, 1);
      margin-top: 0.3rem;
      padding: 24px 0 4px;

      .header {
        display: flex;
        justify-content: space-around;
        height: 0.34rem;

        .title {
          width: calc(100% - 2.6rem);
          text-align: left;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 28px;
          color: #333333;
        }

        .line {
          width: 1.4rem;
          margin-top: 0.05rem;
          text-align: right;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 20px;
          color: #999999;

          img {
            width: 20px;
            height: 20px;
          }
        }
      }

      .body {
        margin: 24px 0;

        .row {
          display: flex;
          justify-content: space-around;
          align-items: center;
          text-align: center;
          height: 1rem;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 24px;
          color: #666666;

          .item {
            width: 1.4rem;

            img {
              width: 64px;
              height: 64px;
            }

            p {
              margin-top: 0.1rem;
            }
          }
        }

        .service {
          height: 1rem !important;

          .item {
            img {
              width: 0.6rem;
              height: 0.6rem;
            }
          }
        }
      }
    }

    .container-m {
      margin-top: 10px;
    }

    .container-bo {
      margin-top: 10px;
    }
  }
}
</style>
